import * as React from 'react';
import { ServiceView } from '@estee/elc-service';
import { observer } from 'mobx-react';
import { Spinner } from '@estee/elc-spinner';
import { ContentBlockViewController } from '~controllers/ContentBlockViewController';
import { INodeContent } from '~domain/entities/Node';

interface IContentBlockItem {
    nid: number;
}

export interface ContentState {
    content: Map<number, INodeContent>;
}

export interface IContentBlock {
    name: string;
    config: IContentBlockItem;
    viewController: ContentBlockViewController;
    state?: ContentState;
}
const { name } = __serviceInfo__;

@observer
class ContentBlock extends React.Component<IContentBlock> {
    static displayName = 'ContentBlock';

    public async componentDidMount() {
        await this.props.viewController.loaded(this.props);
    }

    public render() {
        const { nid } = this.props.config;
        const content = this.props.viewController.getContent(nid);

        if (!content) {
            return <Spinner isLoading />;
        }

        const { layout } = content;

        if (!layout) {
            return null;
        }

        return <ServiceView name={layout} config={content} serviceName={name} />;
    }
}

export default ContentBlock;
